import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Lock, ShieldCheck } from 'lucide-react';
import { Button } from './Button';
import { ExitIntentPopup } from './ExitIntentPopup';
export function OfferSection() {
  const faqs = [{
    q: '¿Necesito saber de programación?',
    a: 'No, este manual es sobre habilidades humanas, no sobre código.'
  }, {
    q: '¿Sirve para cualquier industria?',
    a: 'Sí, siempre que tu trabajo implique tomar decisiones o tratar con personas.'
  }, {
    q: '¿Cuánto tiempo me tomará notar cambios?',
    a: 'Los cambios en tu percepción de valor comienzan desde el día 1 con el cambio de comunicación.'
  }, {
    q: '¿Es un curso en video?',
    a: 'No, es un paquete de implementación rápida en PDF y plantillas para que actúes de inmediato.'
  }, {
    q: '¿La IA realmente no puede hacer lo que enseñas?',
    a: 'La IA predice, el ser humano decide. Aquí aprendes a ser el que decide.'
  }];
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  const basePrice = 7.97;
  const bumpPrice = 7.77;
  const totalPrice = basePrice + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  const buildCartUrl = () => {
    if (bump1 && bump2) return 'https://tumentesoberana.com/cart/48614976159963:1';
    if (bump1) return 'https://tumentesoberana.com/cart/48614964691163:1';
    if (bump2) return 'https://tumentesoberana.com/cart/48614970032347:1';
    return 'https://tumentesoberana.com/cart/48610738602203:1';
  };
  const handleCheckout = () => {
    if (!bump1 && !bump2) {
      setShowUpsell(true);
      return;
    }
    window.open(buildCartUrl(), '_blank', 'noopener,noreferrer');
  };
  return <section className="py-20 px-4 bg-dark-800 border-t border-gold-500/10" data-id="element-218">
      <div className="max-w-4xl mx-auto" data-id="element-219">
        {/* Proof */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-24 bg-gradient-to-r from-gold-500/10 to-transparent p-8 md:p-12 rounded-2xl border-l-4 border-gold-500" data-id="element-220">
          <p className="text-xl md:text-2xl font-serif text-white italic leading-relaxed" data-id="element-221">
            "En solo 7 días, dejarás de ser un 'ID de usuario' invisible en
            Slack para convertirte en la persona a la que llaman cuando los
            datos no son suficientes. Pasarás de la ansiedad por la
            obsolescencia a la seguridad de quien sabe que su intuición es la
            moneda más cara del mercado actual."
          </p>
        </motion.div>

        {/* FAQ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-24" data-id="element-222">
          <h2 className="text-3xl font-serif text-white mb-8 text-center" data-id="element-223">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-224">
            {faqs.map((faq, index) => <div key={index} className="bg-dark-900 rounded-lg border border-gray-800 overflow-hidden" data-id="element-225">
                <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenFaq(openFaq === index ? null : index)} data-id="element-226">
                  <span className="font-medium text-white" data-id="element-227">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-228" />
                </button>
                <AnimatePresence data-id="element-229">
                  {openFaq === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="px-6 pb-4 text-gray-400" data-id="element-230">
                      <p data-id="element-231">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>

        {/* Offer */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} id="offer" className="bg-dark-900 rounded-3xl p-8 md:p-12 border-2 border-gold-500 shadow-[0_0_50px_rgba(201,168,76,0.1)] text-center relative overflow-hidden" data-id="element-232">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-233"></div>

          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-234">
            Recupera tu soberanía profesional hoy mismo.
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-235">
            Por el precio de un par de cafés, obtén la estrategia completa para
            dejar de temerle al futuro y empezar a liderarlo.
          </p>

          <div className="mb-10" data-id="element-236">
            <span className="text-gray-400 text-sm uppercase tracking-widest block mb-2" data-id="element-237">
              Inversión única
            </span>
            <motion.span key={totalPrice} initial={{
            scale: 1.15,
            opacity: 0.7
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20
          }} className="text-6xl font-serif text-gold-500 font-bold inline-block" data-id="element-238">
              ${totalPrice.toFixed(2)}{' '}
              <span className="text-2xl text-gold-500/70" data-id="element-239">USD</span>
            </motion.span>
          </div>

          <Button onClick={handleCheckout} className="w-full md:w-auto text-lg px-12 py-5 mb-6" data-id="element-240">
            RECLAMAR MI BLINDAJE HUMANO AHORA
          </Button>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-400 mb-4" data-id="element-241">
            <div className="flex items-center" data-id="element-242">
              <ShieldCheck className="w-5 h-5 text-green-500 mr-2" data-id="element-243" />
              Acceso inmediato tras la compra
            </div>
            <div className="flex items-center" data-id="element-244">
              <Lock className="w-5 h-5 text-gold-500 mr-2" data-id="element-245" />
              Pago seguro y cifrado
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 bg-dark-700/40 border border-gold-500/15 rounded-full px-5 py-2.5 mb-10 w-fit mx-auto" data-id="element-246">
            <ShieldCheck className="w-5 h-5 text-gold-500" data-id="element-247" />
            <span className="text-white text-sm font-medium" data-id="element-248">
              Garantía de reembolso de 7 días
            </span>
          </div>

          {/* Order Bump 1 */}
          <motion.div animate={{
          borderColor: bump1 ? 'rgba(201,168,76,0.7)' : 'rgba(201,168,76,0.4)',
          boxShadow: bump1 ? '0 0 20px rgba(201,168,76,0.15)' : '0 0 0px rgba(201,168,76,0)'
        }} className="max-w-lg mx-auto mb-6 bg-dark-700/50 border-2 border-dashed rounded-xl p-5 text-left relative overflow-hidden" data-id="element-249">
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-gold-500/5 to-transparent -z-0" animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            repeatDelay: 4,
            ease: 'easeInOut'
          }} data-id="element-250" />
            <div className="relative z-10" data-id="element-251">
              <div className="flex items-start gap-4" data-id="element-252">
                <img src="https://cdn.magicpatterns.com/uploads/2X2WG4gw7GPNcb7NPA1GSj/Order_bumps_1.png" alt="La Auditoría de los 10 Minutos" className="w-24 h-24 object-cover object-center rounded-lg flex-shrink-0" data-id="element-253" />
                <div className="flex-1" data-id="element-254">
                  <div className="flex items-center gap-2 mb-2" data-id="element-255">
                    <input type="checkbox" id="bump1" checked={bump1} onChange={e => setBump1(e.target.checked)} className="w-5 h-5 accent-gold-500 cursor-pointer" data-id="element-256" />
                    <label htmlFor="bump1" className="text-gold-400 font-bold text-sm cursor-pointer uppercase tracking-wide" data-id="element-257">
                      ⚡️ Sí, ¡añádelo a mi pedido!
                    </label>
                  </div>
                  <h4 className="text-white font-serif text-base" data-id="element-258">
                    LA AUDITORÍA DE LOS 10 MINUTOS
                  </h4>
                </div>
              </div>
              <p className="text-gray-400 text-xs leading-relaxed mt-3" data-id="element-259">
                ¿Quieres saber EXACTAMENTE qué tareas de tu lunes te están
                haciendo sustituible? Recibe la hoja de cálculo inteligente que
                califica tu agenda actual y te dice dónde está tu verdadero
                blindaje. Deja de adivinar y empieza a medir tu relevancia real.
                Solo un clic para obtener tu Semáforo de Riesgo.
              </p>
              <p className="text-gold-500 font-bold text-sm mt-2" data-id="element-260">
                Solo $7.77 USD
              </p>
            </div>
          </motion.div>

          {/* Order Bump 2 */}
          <motion.div animate={{
          borderColor: bump2 ? 'rgba(201,168,76,0.7)' : 'rgba(201,168,76,0.4)',
          boxShadow: bump2 ? '0 0 20px rgba(201,168,76,0.15)' : '0 0 0px rgba(201,168,76,0)'
        }} className="max-w-lg mx-auto mb-10 bg-dark-700/50 border-2 border-dashed rounded-xl p-5 text-left relative overflow-hidden" data-id="element-261">
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-gold-500/5 to-transparent -z-0" animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            repeatDelay: 5,
            ease: 'easeInOut'
          }} data-id="element-262" />
            <div className="relative z-10" data-id="element-263">
              <div className="flex items-start gap-4" data-id="element-264">
                <img src="https://cdn.magicpatterns.com/uploads/bWzSXZGGkbU54AP1pjDwGr/Order_Bumps_2.png" alt="Pack de Cláusulas Anty-IA" className="w-24 h-24 object-cover object-center rounded-lg flex-shrink-0" data-id="element-265" />
                <div className="flex-1" data-id="element-266">
                  <div className="flex items-center gap-2 mb-2" data-id="element-267">
                    <input type="checkbox" id="bump2" checked={bump2} onChange={e => setBump2(e.target.checked)} className="w-5 h-5 accent-gold-500 cursor-pointer" data-id="element-268" />
                    <label htmlFor="bump2" className="text-gold-400 font-bold text-sm cursor-pointer uppercase tracking-wide" data-id="element-269">
                      ⚡️ Sí, ¡añádelo a mi pedido!
                    </label>
                  </div>
                  <h4 className="text-white font-serif text-base" data-id="element-270">
                    EL PACK DE CLÁUSULAS Y CONTRATOS "ANTY-IA"
                  </h4>
                </div>
              </div>
              <p className="text-gray-400 text-xs leading-relaxed mt-3" data-id="element-271">
                Recibe las 3 plantillas legales esenciales para blindar tus
                contratos y defender tu tarifa frente a clientes que creen que
                la IA es gratis. No dejes que cuestionen tu valor; ponlo por
                escrito desde el principio.
              </p>
              <p className="text-gold-500 font-bold text-sm mt-2" data-id="element-272">
                Solo $7.77 USD
              </p>
            </div>
          </motion.div>

          {/* Descarga inmediata note */}
          <p className="text-gray-400 text-sm mb-6" data-id="element-273">
            Descarga inmediata · Empieza hoy · Solo necesitas tu celular
          </p>

          {/* Price breakdown */}
          <div className="max-w-sm mx-auto text-left border-t border-gray-700/50 pt-6 space-y-3" data-id="element-274">
            <div className="flex justify-between items-center" data-id="element-275">
              <span className="text-gray-300 text-sm" data-id="element-276">
                El Anti-Manual de la IA (Guía Maestra)
              </span>
              <span className="text-gray-500 text-sm line-through" data-id="element-277">$47.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-278">
              <span className="text-gray-300 text-sm" data-id="element-279">
                Matriz de Irreemplazabilidad
              </span>
              <span className="text-gray-500 text-sm line-through" data-id="element-280">$27.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-281">
              <span className="text-gray-300 text-sm" data-id="element-282">
                El Puente de 21 Días
              </span>
              <span className="text-gray-500 text-sm line-through" data-id="element-283">$37.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-284">
              <span className="text-gray-300 text-sm" data-id="element-285">
                Guiones de Negociación "High-Touch"
              </span>
              <span className="text-gray-500 text-sm line-through" data-id="element-286">$27.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-287">
              <span className="text-gray-300 text-sm" data-id="element-288">
                Checklist de Diagnóstico de Obsolescencia
              </span>
              <span className="text-gray-500 text-sm line-through" data-id="element-289">$17.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-290">
              <span className="text-gray-300 text-sm" data-id="element-291">
                Bonus: 5 Prompts de Soberanía
              </span>
              <span className="text-gray-500 text-sm line-through" data-id="element-292">$27.00</span>
            </div>

            <AnimatePresence data-id="element-293">
              {bump1 && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="flex justify-between items-center" data-id="element-294">
                  <span className="text-gold-400 text-sm" data-id="element-295">
                    ⚡ La Auditoría de los 10 Minutos
                  </span>
                  <span className="text-gold-400 text-sm font-semibold" data-id="element-296">
                    +$7.77
                  </span>
                </motion.div>}
              {bump2 && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="flex justify-between items-center" data-id="element-297">
                  <span className="text-gold-400 text-sm" data-id="element-298">
                    ⚡ Pack Cláusulas Anty-IA
                  </span>
                  <span className="text-gold-400 text-sm font-semibold" data-id="element-299">
                    +$7.77
                  </span>
                </motion.div>}
            </AnimatePresence>

            <div className="border-t border-gray-700/50 pt-3 mt-3" data-id="element-300">
              <div className="flex justify-between items-center mb-2" data-id="element-301">
                <span className="text-white font-semibold" data-id="element-302">Valor Total</span>
                <span className="text-gray-500 line-through font-semibold" data-id="element-303">
                  $182.00
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-304">
                <span className="text-gold-400 font-bold text-lg" data-id="element-305">
                  Hoy pagas solo
                </span>
                <motion.span key={totalPrice} initial={{
                scale: 1.15,
                opacity: 0.7
              }} animate={{
                scale: 1,
                opacity: 1
              }} transition={{
                type: 'spring',
                stiffness: 300,
                damping: 20
              }} className="text-gold-400 font-bold text-2xl" data-id="element-306">
                  ${totalPrice.toFixed(2)}
                </motion.span>
              </div>

              <div className="mt-6" data-id="element-307">
                <Button onClick={handleCheckout} className="w-full text-base px-8 py-4" data-id="element-308">
                  RECLAMAR MI BLINDAJE HUMANO AHORA
                </Button>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Círculo Privado Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-16 text-center" data-id="element-309">
          <h3 className="text-2xl md:text-3xl font-serif text-white mb-4" data-id="element-310">
            Accede al Círculo Privado donde continúa tu transformación
          </h3>
          <p className="text-gray-300 max-w-2xl mx-auto mb-8" data-id="element-311">
            He creado un espacio privado y exclusivo de expansión, donde tendrás
            acceso a contenido de alto valor diseñado para acompañarte en cada
            etapa de tu crecimiento personal, ético y profesional.
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/okaqnpdLdPzi8H2JWp7QCu/tempImagejgp39B.jpg" alt="Círculo Privado en Telegram" className="mx-auto max-w-full md:max-w-2xl rounded-xl shadow-xl shadow-gold-500/10 mb-8" data-id="element-312" />

          <div className="flex flex-col items-center gap-3 mb-8 text-gray-300" data-id="element-313">
            <div className="flex items-center gap-2" data-id="element-314">
              <span className="text-gold-500" data-id="element-315">✦</span>
              <span data-id="element-316">
                Cursos en videos + contenido en constante actualización
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-317">
              <span className="text-gold-500" data-id="element-318">✦</span>
              <span data-id="element-319">Acceso inmediato, cupos limitados</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-320">
              <span className="text-gold-500" data-id="element-321">✦</span>
              <span data-id="element-322">Solo para personas comprometidas con su crecimiento</span>
            </div>
          </div>

          <a href="https://t.me/Amaeliabot" target="_blank" rel="noopener noreferrer" data-id="element-323">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-[#229ED9] hover:bg-[#1a8ac2] text-white font-bold py-4 px-10 rounded-lg shadow-[0_0_15px_rgba(34,158,217,0.3)] transition-colors duration-300 text-lg" data-id="element-324">
              ✈️ ACCEDER AHORA
            </motion.button>
          </a>
          <p className="text-gray-400 text-sm mt-4 italic" data-id="element-325">
            Cursos, Recursos y Comunidad en un solo lugar.
          </p>
        </motion.div>
      </div>
      <ExitIntentPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} onDecline={() => setShowUpsell(false)} data-id="element-326" />
    </section>;
}